import React, { useEffect, useState } from 'react';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { compensiAssicurazioni } from '../../lib/fetch/dashboard';
import DashboardDetailCompensiPresentational from './DashboardDetailCompensiPresentational';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT } = process.env;

function DashboardDetailAssicurazioniCompensi(props) {
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken } = {}] = useAuth();
  const { t } = useTranslation('DASHBOARD');
  const alert = useAlert();

  const [data, setData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: NumberParam,
    insuranceStartYear: NumberParam,
    insuranceStartMonth: NumberParam,
    insuranceEndYear: NumberParam,
    insuranceEndMonth: NumberParam,
    policy_code: withDefault(StringParam, ''),
    agencyType: withDefault(StringParam, ''),
    admin_cf: withDefault(StringParam, ''),
    customer: withDefault(StringParam, ''),
    customerType: withDefault(StringParam, ''),
    active: withDefault(StringParam, ''),
  });

  const {
    year,
    limit,
    offset,
    insuranceStartYear,
    insuranceStartMonth,
    insuranceEndYear,
    insuranceEndMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    agencyType,
  } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.insuranceStartYear &&
        queryDiff.insuranceStartYear !== insuranceStartYear) || // first search
      (insuranceStartYear && queryDiff.insuranceStartYear === '') || // search deleted
      (queryDiff.insuranceStartMonth &&
        queryDiff.insuranceStartMonth !== insuranceStartMonth) || // first search
      (insuranceStartMonth && queryDiff.insuranceStartMonth === '') ||
      (queryDiff.insuranceEndYear &&
        queryDiff.insuranceEndYear !== insuranceEndYear) || // first search
      (insuranceEndYear && queryDiff.insuranceEndYear === '') || // search deleted
      (queryDiff.insuranceEndMonth &&
        queryDiff.insuranceEndMonth !== insuranceEndMonth) || // first search
      (insuranceEndMonth && queryDiff.insuranceEndMonth === '') || // search deleted
      (queryDiff.policy_code && queryDiff.policy_code !== policy_code) || // first search
      (policy_code && queryDiff.policy_code === '') || // search deleted
      (queryDiff.admin_cf && queryDiff.admin_cf !== admin_cf) || // first search
      (admin_cf && queryDiff.admin_cf === '') || // search deleted
      (queryDiff.customer && queryDiff.customer !== customer) || // first search
      (customer && queryDiff.customer === '') || // search deleted
      (queryDiff.customerType && queryDiff.customerType !== customerType) || // first search
      (customerType && queryDiff.customerType === '') || // search deleted
      (queryDiff.active && queryDiff.active !== active) || // first search
      (active && queryDiff.active === '') || // search deleted
      (queryDiff.agencyType && queryDiff.agencyType !== agencyType) || // first search
      (agencyType && queryDiff.agencyType === '') || // search deleted
      (queryDiff.year && queryDiff.year !== year) ||
      (year && queryDiff.year === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchCompensiAssicurazioni = async () => {
    showLoading();

    const { error, headers, data } = await compensiAssicurazioni({
      newToken,
      year,
      limit,
      offset,
      insuranceStartYear,
      insuranceStartMonth,
      insuranceEndYear,
      insuranceEndMonth,
      policy_code,
      admin_cf,
      customer,
      customerType,
      active,
      agencyType,
    });

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setData(data.insurances);
    setTotal(Number(headers['x-total-count']));
    hideLoading();
  };

  const fetchCompensiAssicurazioniExport = async () => {
    showLoading();

    const { error, headers, data } = await compensiAssicurazioni({
      newToken,
      year,
      limit: 5000,
      offset: 0,
      insuranceStartYear,
      insuranceStartMonth,
      insuranceEndYear,
      insuranceEndMonth,
      policy_code,
      admin_cf,
      customer,
      customerType,
      active,
      agencyType,
    });

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setData(data);
    setTotal(Number(headers['x-total-count']));
    hideLoading();
  };

  useEffect(() => {
    fetchCompensiAssicurazioni();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    year,
    limit,
    offset,
    insuranceStartYear,
    insuranceStartMonth,
    insuranceEndYear,
    insuranceEndMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    agencyType,
  ]);

  return (
    <DashboardDetailCompensiPresentational
      data={data}
      dataExport={dataExport}
      fetchCompensiExport={fetchCompensiAssicurazioniExport}
      isReady={isReady}
      setIsReady={setIsReady}
      year={year}
      query={query}
      total={total}
      onFilter={onFilter}
      {...props}
    />
  );
}

export default DashboardDetailAssicurazioniCompensi;
